import { apiFetch } from "./client";

export const productApi = {
  getFeatured: () => apiFetch("/products/featured"),
  getProducts: ({ page = 1, name = "", type = "", perPage } = {}) => {
    const params = new URLSearchParams({ page: String(page) });
    if (name) params.set("name", name);
    if (type) params.set("type", type);
    if (perPage) params.set("per_page", String(perPage));
    return apiFetch(`/products?${params.toString()}`);
  },
  addProduct: (payload) =>
    apiFetch("/admin/products", {
      method: "POST",
      body: JSON.stringify(payload),
    }),
  updateProduct: (productId, payload) =>
    apiFetch(`/admin/products/${productId}`, {
      method: "PUT",
      body: JSON.stringify(payload),
    }),
  deleteProduct: (productId) =>
    apiFetch(`/admin/products/${productId}`, {
      method: "DELETE",
    }),
  uploadImage: async (file) => {
    const formData = new FormData();
    formData.append("image", file);

    // const response = await fetch("http://localhost:5000/api/admin/upload-image", {
    //   method: "POST",
    //   credentials: "include",
    //   body: formData,
    // });

    const response = await fetch("/api/admin/upload-image", {
      method: "POST",
      credentials: "include",
      body: formData,
    });

    const data = await response.json();
    if (!response.ok || !data.success) {
      throw new Error(data.message || "Image upload failed");
    }
    return data;
  },
};
